export default __webpack_public_path__ + "664117bd3b1ccd5241a5477805a80999.svg";